import { v4 } from "uuid";

export default class Ventana {
    constructor() {
        this.posicionZ = 1;
        // this.id = v4();
        // this.modal = false;
    }

    /**@abstract */
    getReactElement() {}

    /**@abstract */
    puedeHacersePasarPor(ventana) {}
}
